(function () {
  'use strict';

  function initSizeChartModal(modal) {
    if (!modal || modal.dataset.sizeChartReady === 'true') return;
    modal.dataset.sizeChartReady = 'true';

    var modalId = modal.id;
    var openButtons = document.querySelectorAll('[data-size-chart-open="' + modalId + '"]');
    var closeButtons = modal.querySelectorAll('[data-size-chart-close]');
    var tabs = modal.querySelectorAll('[data-size-chart-tab]');
    var panels = modal.querySelectorAll('[data-size-chart-panel]');

    function applyGlobalChart() {
      var source = document.getElementById('GlobalSizeChartSource');
      if (!source || source.dataset.force !== 'true' || !source.dataset.image) {
        return;
      }
      if (modal.dataset.sizeChartMetafield !== 'true') {
        return;
      }

      var panel = modal.querySelector('[data-size-chart-panel="chart"]');
      if (!panel || panel.querySelector('.product-size-chart__image--global')) {
        return;
      }

      var tableWrap = panel.querySelector('.product-size-chart__table-wrap');
      if (tableWrap) {
        tableWrap.hidden = true;
      }

      panel.querySelectorAll('.product-size-chart__image').forEach(function (img) {
        img.hidden = true;
      });

      var img = document.createElement('img');
      img.className = 'product-size-chart__image product-size-chart__image--global';
      img.src = source.dataset.image;
      img.alt = source.dataset.alt || 'Size chart';

      var unit = panel.querySelector('.product-size-chart__unit');
      if (unit && unit.parentNode) {
        unit.insertAdjacentElement('afterend', img);
      } else {
        panel.insertBefore(img, panel.firstChild);
      }
    }

    function openModal() {
      applyGlobalChart();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function activateTab(name) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-size-chart-tab') === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-size-chart-panel') === name;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal();
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-size-chart-tab'));
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-size-chart-modal]').forEach(initSizeChartModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
